<div class="float-item menu-item-tile">
    <div class="image-container" *ngIf="img"
    [ngStyle]="img ? {'background-image': 'url(' + img + ')'} : {'background-image': 'none'}">
        <!-- <div class="brand-logo" *ngIf="brandLogo" 
        [ngStyle]="brandLogo ? {'background-image': 'url(' + brandLogo + ')'} : {'background-image': 'none'}"></div> -->
    </div>
</div>